import React from 'react';

import {routes} from '@constants/routes';
import {SPIIDEO_COMPETITOR_MAPPING, SPIIDEO_STADIUM_MAPPING} from '@constants/resources';

import SpiideoCompetitorsIndex from '../views/SpiideoCompetitorsIndex';
import SpiideoCompetitorMappingEdit from '../views/SpiideoCompetitorMappingEdit';
import SpiideoVenuesIndex from '../views/SpiideoVenuesIndex';
import SpiideoVenuesEdit from '../views/SpiideoVenuesEdit';

export const isSpiideoVenuesFormPath = (path) => (
    path === routes.spiideoMappings.venuesAdd.path
    || path === routes.spiideoMappings.venuesEdit.path
);

export const isSpiideoCompetitorsFormPath = (path) => (
    path === routes.spiideoMappings.competitorAdd.path
    || path === routes.spiideoMappings.competitorEdit.path
);

export const getSpiideoMappingsDocumentTitle = (path) => (
    Object.values(routes.spiideoMappings).find((route) => route.path === path)?.title
    || 'AV-CMP'
);

export const createTabs = (path) => ({
    [routes.spiideoMappings.competitors.path]: {
        key: routes.spiideoMappings.competitors.path,
        url: 'spiideoMappings.competitors',
        text: 'Competitors',
        render: isSpiideoCompetitorsFormPath(path)
            ? <SpiideoCompetitorMappingEdit/>
            : <SpiideoCompetitorsIndex/>,
        resource: SPIIDEO_COMPETITOR_MAPPING,
    },
    [routes.spiideoMappings.venues.path]: {
        key: routes.spiideoMappings.venues.path,
        url: 'spiideoMappings.venues',
        text: 'Venues',
        render: isSpiideoVenuesFormPath(path)
            ? <SpiideoVenuesEdit/>
            : <SpiideoVenuesIndex/>,
        resource: SPIIDEO_STADIUM_MAPPING,
    },
});

createTabs.displayName = 'createSpiideoMappingsTabs';
